import { KeyboardEvent, useCallback } from 'react'
import { MenuItemLink } from '../menu-item-data'
import { useMenuContext } from './use-menu-context'

const SPACE = ' '

export const useSubmenuItem = (
  menuItem: MenuItemLink
): {
  onItemClicked: () => void
  onKeyDown: (e: KeyboardEvent) => void
} => {
  const { visitLink } = useMenuContext()

  const onItemClicked = useCallback(() => {
    visitLink(menuItem)
  }, [visitLink, menuItem])

  const onKeyDown = useCallback(
    (event: KeyboardEvent): void => {
      switch (event.key) {
        case SPACE:
        case 'Enter':
          visitLink(menuItem)
          event.preventDefault()
          break
      }
    },
    [visitLink, menuItem]
  )
  return { onItemClicked, onKeyDown }
}
